<!-- 专家修改 和 导师修改 -->
<template>
  <div class="detail">
    <div class="top">
      <div>
        <div class="title">Curriculum Vitae</div>
        <zlr-menu-row :menuList="menuList"></zlr-menu-row>
      </div>
    </div>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
// components
import ZlrMenuRow from '_c/menu/menu-row'
import { mapState } from 'vuex'
export default {
  name: '',
  components: {
    ZlrMenuRow
  },
  data () {
    return {
      menuList: [

        {
          title: '导师修改',
          name: ['cv-rl-cv-mentor']
        }
      ],
      detail: {}
    }
  },
  computed: {
    ...mapState({
      'userInfo': (state) => state.user.userInfo
    }),
    expertCount () {
      return this.userInfo.packageInfo && this.userInfo.packageInfo.expertCount
    }
  },
  mounted () {
    this.setMenu()
  },
  methods: {
    setMenu () {
      let expertCount = this.expertCount
      let experrMenu = {
        title: '专家修改',
        name: ['cv-rl-cv-expert']
      }
      // 判断是否有专家修改的权限
      if (expertCount > 0 && this.menuList.findIndex(item => item.title === '专家修改') === -1) {
        this.menuList.splice(0, 0, experrMenu)
      }
    }
  },
  watch: {
    userInfo (newValue) {
      this.setMenu()
    }
  }
}
</script>
<style lang='less' scoped>
.detail {
  margin-top: 26px;
  .top {
    background-color: #fff;
    > div {
      padding-top: 20px;
      width: 1280px;
      margin: 0 auto;
    }
    .title {
      text-align: center;
      font-size: 24px;
      color: rgba(0, 0, 0, 0.85);
      text-align: center;
      line-height: 36px;
      margin-bottom: 64px;
    }
  }
}
</style>
